
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investering",
      function () {
        return require("private-next-pages/investering/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investering"])
      });
    }
  